// Vendor Imports
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import * as bootstrap from 'bootstrap';
import Choices from 'choices.js';
//import 'select2';  // Импорт select2
window.Choices = Choices;
window.bootstrap = bootstrap
//import GLightbox from 'glightbox';
import './misc';

import Swiper, {
    Navigation,
    Pagination,
    Scrollbar,
    Autoplay,
    Mousewheel,
    Keyboard,
    Parallax,
    Lazy,
    EffectFade,
    Thumbs,
    Controller,
} from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Mousewheel, Keyboard, Parallax, Lazy, EffectFade, Thumbs, Controller]);

window.Swiper = Swiper;

const requireAll = (r) => {
    console.log('🟢 SVG-файлы, которые будут импортированы в спрайт:');
    r.keys().forEach((path) => {
        console.log(` → ${path}`);
        r(path);
    });
};


console.log('SVG-файлы');
require.context('@sprite', true, /\.svg$/);


// Framework import.
//import './components/swiper';
import './components/popover';
/*import './components/aos';
import './components/choices';
import './components/checkout';
import './components/hotspots';
import './components/image-zoom';
import './components/navbar';
import './components/nouislider';
import './components/offcanvas';

import './components/product';
import './components/scroll-to';
import './components/search';
import './components/simplebar';

import './components/tooltip';

// theme misc js
*/
document.addEventListener("DOMContentLoaded", () => {
    const spriteUrl = '/assets/template/sprite/sprite.svg?30082025';
    const replaceUrl = '/assets/template/sprite/sprite.svg';

    fetch(spriteUrl)
        .then(res => res.text())
        .then(svgText => {
            const div = document.createElement('div');
            div.style.display = 'none';
            div.innerHTML = svgText;
            document.body.insertBefore(div, document.body.firstChild);

            // Заменить xlink:href="/assets/template/sprite/sprite.svg#icon-name" → "#icon-name"
            document.querySelectorAll('use').forEach(use => {
                const href = use.getAttribute('xlink:href') || use.getAttribute('href');
                if (href && href.startsWith(replaceUrl)) {
                    const fragment = href.substring(replaceUrl.length); // например, "#icon-call"
                    use.setAttribute('xlink:href', fragment);
                }
            });
        })
        .catch(err => {
            console.error('Ошибка загрузки SVG спрайта:', err);
        });
});
/*document.addEventListener('DOMContentLoaded', function () {
    // Удаляем data-bs-toggle на десктопе
    function updateDropdownToggleBehavior() {
        document.querySelectorAll('.dropdown-hover .toggle').forEach(btn => {
            const isMobile = window.innerWidth < 768;
            if (isMobile) {
                btn.setAttribute('data-bs-toggle', 'dropdown');
            } else {
                btn.removeAttribute('data-bs-toggle');
            }
        });
    }

    updateDropdownToggleBehavior();
    window.addEventListener('resize', updateDropdownToggleBehavior);
});*/
document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('menuDropdown');
    const dropdownContainer = btn?.nextElementSibling?.classList.contains('dropdown-menu') ? btn.nextElementSibling : null;
    const customMenu = dropdownContainer?.querySelector('.dropdown-menu-inner');
    const dropdown = document?.querySelector('.dropdown');
    const burgers = dropdown.querySelectorAll('.hamburger');
    console.log('[INIT] DOMContentLoaded');
    console.log('[CHECK] btn:', btn);
    console.log('[CHECK] dropdownContainer:', dropdownContainer);
    console.log('[CHECK] customMenu:', customMenu);

    if (!btn || !customMenu) {
        console.warn('[ABORT] Не найден btn или customMenu. Скрипт остановлен.');
        return;
    }

    let isClickBound = false;

    function isMobile() {
        const mobile = window.innerWidth < 768;
        console.log('[CHECK] isMobile():', mobile);
        return mobile;
    }

    function closeAllMenus() {
        console.log('[ACTION] Закрытие всех открытых меню');
        document.querySelectorAll('.dropdown-menu-inner.show').forEach(menu => {
            console.log('[CLOSE] menu:', menu);
            menu.classList.remove('show');
            burgers.forEach(b => b.classList.remove('is-active'));
        });
    }

    function setupMobileDropdown() {
        if (!isClickBound) {
            console.log('[BIND] Навешиваем обработчики (click, outsideClick)');
            btn.addEventListener('click', onClick);
            document.addEventListener('click', onOutsideClick);
            isClickBound = true;
        } else {
            console.log('[SKIP] Обработчики уже навешаны, не дублируем');
        }
    }

    function removeMobileDropdown() {
        if (isClickBound) {
            console.log('[UNBIND] Удаляем обработчики (click, outsideClick)');
            btn.removeEventListener('click', onClick);
            document.removeEventListener('click', onOutsideClick);
            isClickBound = false;
        }
        console.log('[CLEANUP] Прячем customMenu');
        customMenu.classList.remove('show');
    }

    function onClick(e) {
        console.log('[EVENT] btn.click');

        if (!isMobile()) {
            console.log('[SKIP] Не mobile — выход из onClick');
            return;
        }

        e.preventDefault();

        const isShown = customMenu.classList.contains('show');
        console.log('[STATE] customMenu.classList.contains("show"):', isShown);

        closeAllMenus();

        if (!isShown) {
            console.log('[ACTION] Показываем customMenu');
            customMenu.classList.add('show');
        } else {
            console.log('[ACTION] Меню уже показано — ничего не делаем');
        }
    }

    function onOutsideClick(e) {
        if (!isMobile()) return;
        if (!dropdown.contains(e.target)) {
            console.log('[EVENT] Click вне dropdown — скрываем меню');
            customMenu.classList.remove('show');
            burgers.forEach(b => b.classList.remove('is-active'));
        }
    }

    function update() {
        console.log('[UPDATE] Проверяем ширину и режим');
        if (isMobile()) {
            console.log('[MODE] Mobile — активируем клик-меню');
            setupMobileDropdown();
        } else {
            console.log('[MODE] Desktop — удаляем клики, включаем hover');
            removeMobileDropdown();
        }
    }

    update();

    window.addEventListener('resize', () => {
        console.log('[EVENT] resize');
        update();
    });
});


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.dropdown-hover').forEach(dropdown => {
        const burgers = dropdown.querySelectorAll('.hamburger');
        if (burgers.length === 0) return;

        dropdown.addEventListener('mouseenter', () => {
            burgers.forEach(b => b.classList.add('is-active'));
        });

        dropdown.addEventListener('mouseleave', () => {
            burgers.forEach(b => b.classList.remove('is-active'));
        });
    });

    const accordion = document.getElementById('faqAccordion');

    if (accordion) {
        accordion.addEventListener('show.bs.collapse', function (event) {
            toggleIcons(event.target, true);
        });

        accordion.addEventListener('hide.bs.collapse', function (event) {
            toggleIcons(event.target, false);
        });
    }


    const accordionlkSteps = document.getElementById('lkSteps');

    if (accordionlkSteps) {
        accordionlkSteps.addEventListener('show.bs.collapse', function (event) {
            toggleIcons(event.target, true);
        });

        accordionlkSteps.addEventListener('hide.bs.collapse', function (event) {
            toggleIcons(event.target, false);
        });
    }
    function toggleIcons(collapseEl, isOpen) {
        const button = collapseEl.closest('.accordion-item').querySelector('.accordion-button');
        const iconOpen = button.querySelector('[data-icon="opened"]');
        const iconClosed = button.querySelector('[data-icon="closed"]');

        if (isOpen) {
            iconOpen.classList.remove('d-none');
            iconClosed.classList.add('d-none');
        } else {
            iconOpen.classList.add('d-none');
            iconClosed.classList.remove('d-none');
        }
    }

    const modalEl = document.getElementById('authModal');
    const defaultForm = '#form-login';

    if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        let nextFormSelector = null;  // null => ручное закрытие; строка => программное переключение
        let isHiding = false;         // чтобы не дергать hide() повторно

        // Переключение форм (запрашиваем переключение и прячем модалку)
        document.querySelectorAll('.switch-form').forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = el.dataset.target;
                if (!targetId) return;

                // если уже идет скрытие — просто обновим цель
                nextFormSelector = targetId;

                if (!isHiding) {
                    isHiding = true;
                    modal.hide(); // переключим после полного скрытия
                }
            });
        });

        // Срабатывает после завершения анимации скрытия
        modalEl.addEventListener('hidden.bs.modal', () => {
            if (nextFormSelector) {
                // программное переключение
                switchToForm(nextFormSelector);
                nextFormSelector = null;
                isHiding = false;
                modal.show();
            } else {
                // ручное закрытие
                switchToForm(defaultForm);
                isHiding = false;
            }
        });

        // Универсальная функция переключения форм (строго одна active)
        function switchToForm(selector) {
            const target = document.querySelector(selector);
            if (!target) return;

            document.querySelectorAll('.auth-form').forEach(form => {
                form.classList.remove('active');
                form.classList.add('d-none');
            });

            target.classList.remove('d-none');
            // форсируем reflow, чтобы анимация корректно стартовала
            // eslint-disable-next-line no-unused-expressions
            target.offsetWidth;
            target.classList.add('active');
        }
    }








});


const reviewCarouselSmall = new Swiper('.review-swiper', {
    spaceBetween: 0,
    slidesPerView: 1, // значение по умолчанию (мобила)
    roundLengths: true,
    loop: true,
    navigation: {
        nextEl: '.swiper-next-review',
        prevEl: '.swiper-prev-review',
    },
    pagination: {
        el: '.swiper-pagination-custom',
    },
    breakpoints: {
        768: { // >= 768px (например, планшеты и десктоп)
            slidesPerView: 3
        }
    }
});

const coachesCarouselSmall = new Swiper('.coaches-swiper', {
    spaceBetween: 0,
    slidesPerView: 1, // значение по умолчанию (мобила)
    roundLengths: true,
    loop: true,
    navigation: {
        nextEl: '.swiper-next-coach',
        prevEl: '.swiper-prev-coach',
    },
    pagination: {
        el: '.swiper-pagination-custom',
    }
})
// Хранилище для инстансов
window.choicesInstances = window.choicesInstances || new Map();

document.querySelectorAll('.select-choice').forEach(select => {
    const instance = new Choices(select, {
        // опции
    });

    window.choicesInstances.set(select, instance);

    // Добавим иконку
    const container = select.closest('.choices[data-type="select-one"]') || select.parentElement.querySelector('.choices[data-type="select-one"]');
    if (container && !container.querySelector('.custom-arrow')) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("class", "custom-arrow");
        svg.setAttribute("width", "16");
        svg.setAttribute("height", "12");

        const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
        use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "/assets/template/sprite/sprite.svg#icon-arrow-bottom");

        svg.appendChild(use);
        container.appendChild(svg);
    }
});
